<template>
  <!-- 保存到 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="save"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">保存到</h4>
        </div>
        <div class="modal-body">
          <div class="file-move">
            <div class id="treeview-save"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button
            class="btn btn-primary"
            type="button"
            @click="saveToFolder"
            :disabled="isProcessing"
          >
            {{ isProcessing ? "正在保存..." : "确定" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import { saveShareResource } from "@/api/share/share";
import { saveGroupResource } from "@/api/group/group";
export default {
  name: "Save",
  data() {
    return {
      isProcessing: false,
    };
  },
  props: {
    // 保存到的文件夹
    folder: {
      type: Object,
    },
    // 被选择保存的资源
    resources: {
      type: Array,
    },
  },
  computed: {
    shareNumber() {
      return this.$store.state.drive.share.share_number;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
  },
  methods: {
    saveToFolder() {
      if (this.isProcessing) {
        return false;
      }
      this.isProcessing = true;
      if (!this.folder || !this.folder.number) {
        this.$message({
          type: "warning",
          message: "请选择目标文件夹",
        });
        this.isProcessing = false;
        return false;
      }
      if (this.tab === "group-file" || this.tab === "groupdisk-file") {
        this.saveGroupResource();
      } else if (this.tab === "shareme" || this.tab === "groupdisk-share") {
        this.saveShareResource();
      }
    },
    // 将群盘资源保存到网盘
    saveGroupResource() {
      let resources_list = this.resources.map(function (item) {
        return {
          group_resource_number: item.number,
          group_resource_type: item.type,
        };
      });
      let params = {
        target_folder_number: this.folder.number,
        disk_type: this.folder.disk_type,
        resources_list: resources_list,
        group_number: this.groupNumber,
      };
      saveGroupResource(params)
        .then((res) => {
          if (res.status_code === 200) {
            this.isProcessing = false;
            $("#save").modal("hide");
            this.$message({
              type: "success",
              message: res.message,
            });
            if (res.entity.state === 2) {
              return false;
            }
            // 添加任务到队列
            this.$store.commit("addTask", {
              job_id: res.entity.job_id,
              job_type: "",
              run_percent: res.entity.run_percent,
              state: res.entity.state,
              message: "",
            });
            // 触发显示队列组件
            Bus.$emit("changeGlobalPluginStatus", {
              plugin: "showGlobalQueue",
              status: true,
            });
          } else {
            this.isProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 将分享的资源（①分享@我②分享到群）保存到网盘
    saveShareResource() {
      let paramslist = this.resources.map(function (item) {
        return {
          share_resource_number: item.number,
          share_resource_type: item.type,
        };
      });
      let params = {
        share_number: this.shareNumber,
        // share_password: "string",
        target_number: this.folder.number,
        disk_type: this.folder.disk_type,
        paramslist: paramslist,
      };
      saveShareResource(params)
        .then((res) => {
          if (res.status_code === 200) {
            this.isProcessing = false;
            $("#save").modal("hide");
            this.$message({
              type: "success",
              message: res.message,
            });
            if (res.entity.state === 2) {
              return false;
            }
            this.$store.commit("addTask", {
              job_id: res.entity.job_id,
              job_type: "",
              run_percent: res.entity.run_percent,
              state: res.entity.state,
              message: "",
            });
            Bus.$emit("changeGlobalPluginStatus", {
              plugin: "showGlobalQueue",
              status: true,
            });
          } else {
            this.isProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style>
</style>